









import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { CounterColor } from '@/shared/components/counter/counter.enum.ts';
import { CounterInterface } from '@/shared/components/counter/counter.interface.ts';

@Component
export default class Counter extends Vue {
  @Prop() private counter!: CounterInterface;

  // private counterValue = 0;
  private counterValue = this.counter.value;

  private timeLimitAnimation = 1200;
  private timeStepsAnimation = 60;
  private stepsInLimitTime = this.timeLimitAnimation / this.timeStepsAnimation;

  @Watch('counter')
  private watchCounter(newVal: CounterInterface, oldVal: CounterInterface) {
      if (newVal.value) {
        this.counterValue = newVal.value;
      }
  }

  // private created() {
  //   if (this.counter.value) {
  //     // this.animationCounter();
  //   }
  // }

  private animationCounter() {
    let steps!: number;
    if (this.counter.value) {
      if (this.counter.value < 20) {
        steps = 1;
      } else {
        steps = Math.trunc(this.counter.value / this.stepsInLimitTime);
      }
    }

    const animationCounterInterval = setInterval(() => {
      if (this.counter.value) {
        if (this.counterValue && (this.counterValue + steps) < this.counter.value) {
          this.counterValue += steps;
        } else {
          this.counterValue = this.counter.value;
          clearInterval(animationCounterInterval);
        }
      }
    }, 60);
  }
}
